import React from 'react'
import { string, func } from 'prop-types'
import { Button } from '@cobalt/cobalt-react-components'

const NavbarButton = ({ action, actionMessage }) => (
  <Button onClick={() => action()} secondary small>
    {actionMessage}
  </Button>
)

NavbarButton.propTypes = {
  actionMessage: string.isRequired,
  action: func.isRequired
}

export default NavbarButton
